var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLibrary06(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.995117,
    y: 0.529297,
    width: 350,
    height: 233,
    fill: "#2E4491"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155.099 142.118L212.826 114.496L286.072 154.843L228.344 182.466L155.099 142.118Z",
    fill: "#331712"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M210.523 77.6074V77.9302C210.523 77.9302 212.77 79.6434 213.683 80.6304L214.068 80.5745V80.2952L210.523 77.6074Z",
    fill: "#58271E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M203.775 82.6586V83.1675C203.775 83.1675 212.286 83.4034 216.525 87.3016V86.5257C216.525 86.5257 212.77 82.8448 203.775 82.6523V82.6586Z",
    fill: "#58271E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M210.523 77.6086C220.293 77.3168 225.669 82.0902 225.669 82.0902L216.507 86.5346C212.05 82.7978 203.77 82.6613 203.77 82.6613C203.77 82.6613 207.73 80.5135 213.819 80.3832C213.819 80.3832 213.093 79.6756 212.267 78.9866C211.839 78.6327 210.523 77.6086 210.523 77.6086Z",
    fill: "#B54735"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M234.551 100.529L309.038 141.187V143.67L234.551 102.702V100.529Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M309.038 116.359V113.876L235.792 73.5293L233.31 74.7707L309.038 116.359Z",
    fill: "#283B68"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M178.065 130.947L235.793 103.324L309.039 143.671L251.311 171.294L178.065 130.947Z",
    fill: "#4966A8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M178.065 128.464L235.793 100.842L309.039 141.189L251.311 169.122L178.065 128.464Z",
    fill: "#233457"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M178.065 103.634L235.793 76.0117L309.039 116.359L251.311 143.981L178.065 103.634Z",
    fill: "#3B548D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M178.065 101.152L235.793 73.5293L309.039 113.876L251.311 141.499L178.065 101.152Z",
    fill: "#FFBAAD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M178.065 101.152L235.793 73.5293L309.039 113.876L251.311 141.499L178.065 101.152Z",
    fill: "url(#paint0_linear_569_27184)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M178.065 101.152V131.258L251.311 171.605V141.5L178.065 101.152Z",
    fill: "#9A4E41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M178.065 101.152V131.258L251.311 171.605V141.5L178.065 101.152Z",
    fill: "url(#paint1_linear_569_27184)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M308.418 141.499V116.359L251.622 143.051V169.121L308.418 141.499Z",
    fill: "#E1E8FA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M308.418 141.499V116.359L251.622 143.051V169.121L308.418 141.499Z",
    fill: "url(#paint2_linear_569_27184)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.039 113.877V116.36L252.863 143.237V168.37L309.039 141.189V143.672L251.312 171.604V141.499L309.039 113.877Z",
    fill: "#7B3428"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_569_27184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 202,
    y: 83,
    width: 51,
    height: 30
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M217.93 112.263L202.616 103.964L237.476 83.834L252.789 92.1331L217.93 112.263Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_569_27184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.895 105.257C213.839 105.288 213.79 105.319 213.728 105.35L212.021 106.225L207.725 103.699L209.426 102.824C210.866 102.091 212.418 102.234 213.678 102.985C214.919 103.705 215.137 104.543 213.895 105.263M203.15 103.668L215.906 111.172L218.315 109.931L214.156 107.485L216.241 106.411C216.347 106.356 216.453 106.3 216.552 106.244C218.904 104.884 218.613 103.14 216.167 101.706C213.653 100.229 210.351 99.9559 207.713 101.321L203.157 103.668",
    fill: "#4972CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.081 103.878C223.404 104.269 223.479 104.939 224.274 105.386C225.074 105.877 226.347 105.951 227.104 105.56C227.123 105.548 227.141 105.541 227.16 105.529C227.812 105.157 227.75 104.474 226.955 104.002C226.142 103.524 224.863 103.456 224.156 103.828C224.125 103.841 224.1 103.859 224.075 103.872",
    fill: "#4972CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.234 97.8638C228.178 97.8948 228.122 97.9258 228.06 97.9569L226.359 98.8321L222.058 96.2995L223.758 95.4243C225.198 94.6918 226.75 94.8346 228.01 95.5857C229.252 96.3057 229.475 97.1437 228.234 97.8575M217.483 96.2623L230.239 103.773L232.647 102.532L228.488 100.086L230.574 99.0121C230.679 98.9562 230.779 98.9004 230.872 98.8507C233.231 97.4913 232.939 95.7471 230.493 94.307C227.979 92.8297 224.677 92.5565 222.033 93.9159L217.477 96.2623",
    fill: "#4972CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.675 91.0178L240.437 98.5285L242.808 97.3057L230.052 89.7949L227.675 91.0178Z",
    fill: "#4972CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.608 90.0297L240.902 91.9415C239.891 91.296 239.729 90.4146 240.704 89.8497C240.741 89.8249 240.784 89.8062 240.828 89.7814C241.877 89.229 243.441 89.3469 244.614 90.0235M238.575 88.7883C236.29 90.1042 236.706 92.0595 239.568 93.7354C242.591 95.5231 246.123 95.7962 248.804 94.4244C248.897 94.3748 248.99 94.3251 249.077 94.2755C250.964 93.183 251.182 91.8422 249.81 90.6753L247.55 91.8422C247.873 92.2767 247.712 92.7795 246.998 93.1954C246.967 93.214 246.936 93.2326 246.899 93.2513C245.663 93.8782 243.994 93.7541 242.547 92.9037L248.5 89.8373L247.755 89.4028C244.496 87.4847 241.101 87.4785 238.817 88.6579C238.73 88.7013 238.649 88.7448 238.568 88.7945",
    fill: "#4972CE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_569_27184",
    x1: 205.844,
    y1: 93.6232,
    x2: 268.851,
    y2: 104.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5BDB3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_569_27184",
    x1: 178.258,
    y1: 101.457,
    x2: 208.569,
    y2: 136.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B2B1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979729,
    stopColor: "#9A4E41",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_569_27184",
    x1: 260.677,
    y1: 135.173,
    x2: 282.474,
    y2: 155.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibrary06);
export default __webpack_public_path__ + "static/media/library_06.956591c2884a2921c2c8e19fcf5f4ff2.svg";
export { ForwardRef as ReactComponent };